// extracted by mini-css-extract-plugin
module.exports = {"InBox":"InBox_InBox__Oix4s"};